export const translations = {
  fr: {
    appName: "BudgetLens",
    appTagline: "Diagnostic budgétaire client",
    modules: {
      client: "Client",
      revenus: "Revenus",
      depenses: "Dépenses",
      analyse: "Analyse",
      optimisation: "Plan d'optimisation",
      recommandations: "Recommandations",
    },
    nav: {
      exportPdf: "Exporter en PDF",
      reset: "Réinitialiser",
      language: "Langue",
      completed: "Complété",
    },
    client: {
      title: "Informations client",
      subtitle: "Contextualisez le dossier de votre client",
      nom: "Nom",
      prenom: "Prénom",
      telephone: "Téléphone",
      email: "Email",
      adresse: "Adresse",
      situationFamiliale: "Situation familiale",
      nombreEnfants: "Nombre d'enfants",
      statutLogement: "Statut logement",
      objectifPatrimonial: "Objectif patrimonial",
      horizonPlacement: "Horizon de placement",
      situations: {
        celibataire: "Célibataire",
        marie: "Marié(e)",
        pacse: "Pacsé(e)",
        divorce: "Divorcé(e)",
        veuf: "Veuf / Veuve",
      },
      logements: {
        locataire: "Locataire",
        proprietaire: "Propriétaire",
        heberge: "Hébergé(e)",
      },
      horizons: {
        court: "Court terme (< 2 ans)",
        moyen: "Moyen terme (2–5 ans)",
        long: "Long terme (> 5 ans)",
      },
      personal: "Coordonnées",
      family: "Situation & patrimoine",
    },
    revenus: {
      title: "Revenus mensuels",
      subtitle: "Saisie de l'ensemble des revenus du foyer",
      salaire1: "Salaire 1",
      salaire2: "Salaire 2",
      bic: "BIC (Bénéfices Industriels et Commerciaux)",
      bnc: "BNC (Bénéfices Non Commerciaux)",
      dividendes: "Dividendes",
      allocationsCaf: "Allocations CAF",
      pension: "Pension / retraite",
      pensionAlimentaire: "Pension alimentaire reçue",
      autresRevenus: "Autres revenus",
      total: "Total des revenus",
      perMonth: "/ mois",
    },
    depenses: {
      title: "Dépenses mensuelles",
      subtitle: "Répartition détaillée des charges",
      fixes: "Charges fixes",
      credits: "Crédits en cours",
      variables: "Dépenses variables",
      totalFixes: "Sous-total charges fixes",
      totalCredits: "Sous-total crédits",
      totalVariables: "Sous-total dépenses variables",
      totalGeneral: "Total général",
      loyer: "Logement — Loyer",
      chargesCopro: "Logement — Charges locatives / copropriété",
      assuranceHabitation: "Logement — Assurance habitation",
      electricite: "Énergie — Électricité",
      gaz: "Énergie — Gaz",
      eau: "Énergie — Eau",
      telecomInternet: "Télécom — Internet / téléphone",
      mutuelle: "Assurances — Mutuelle santé",
      autresAssurances: "Assurances — Autres (vie, prévoyance)",
      assuranceAuto: "Transport — Assurance auto",
      carburant: "Transport — Carburant",
      entretienVehicule: "Transport — Entretien véhicule",
      creditImmo: "Crédit immobilier",
      creditAuto: "Crédit auto",
      creditConso: "Crédit consommation",
      creditRenouvelable: "Crédit renouvelable",
      autresCredits: "Autres crédits",
      alimentation: "Alimentation — Courses",
      hygienePharmacie: "Hygiène / pharmacie",
      gardeEnfants: "Famille — Garde / cantine / enfants",
      restaurantsSorties: "Loisirs — Restaurants / sorties",
      abonnements: "Loisirs — Abonnements",
      autresVariables: "Divers — Autres dépenses",
    },
    analyse: {
      title: "Analyse budgétaire",
      subtitle: "Indicateurs clés et diagnostic instantané",
      revenusTotaux: "Revenus totaux",
      chargesFixes: "Charges fixes",
      mensualitesCredits: "Mensualités crédits",
      depensesVariables: "Dépenses variables",
      depensesTotales: "Dépenses totales",
      resteAVivre: "Reste à vivre",
      tauxEndettement: "Taux d'endettement",
      poidsChargesFixes: "Poids charges fixes",
      poidsVariables: "Poids dépenses variables",
      mensualiteMax: "Mensualité max banque",
      mensualiteDispo: "Mensualité disponible",
      capaciteEmprunt: "Capacité d'emprunt",
      diagnostic: "Diagnostic global",
      diagnosticSaine: "Situation saine",
      diagnosticSurveiller: "À surveiller",
      diagnosticFragile: "Situation fragile",
      endettementCorrect: "Endettement correct",
      endettementEleve: "Endettement trop élevé",
      ravCorrect: "Reste à vivre correct",
      ravFaible: "Reste à vivre faible",
      budgetCorrect: "Budget global correct",
      budgetOptim: "Budget à optimiser",
      threshold: "Seuil",
      repartition: "Répartition des dépenses",
    },
    optimisation: {
      title: "Plan d'optimisation",
      subtitle: "Simulez les économies potentielles",
      tauxVariables: "Taux d'optimisation dépenses variables",
      tauxFixes: "Taux d'optimisation charges fixes",
      economiesVariables: "Économies sur dépenses variables",
      economiesFixes: "Économies sur charges fixes",
      gainMensuel: "Gain mensuel total potentiel",
      nouveauRav: "Nouveau reste à vivre estimé",
      epargneAnnuelle: "Potentiel d'épargne annuelle",
      nouveauTaux: "Nouveau taux d'endettement",
      before: "Avant",
      after: "Après",
      reset: "Valeurs par défaut",
    },
    recommandations: {
      title: "Recommandations",
      subtitle: "Conseils et opportunités personnalisés",
      alertes: "Alertes",
      infos: "Informations",
      opportunites: "Opportunités",
      labels: {
        endettement: "Endettement",
        rav: "Reste à vivre",
        variables: "Dépenses variables",
        fixes: "Charges fixes",
        rachat: "Rachat de crédits",
        audit: "Audit assurances",
        budget: "Optimisation budget",
      },
      messages: {
        endettementAlerte: "Réduire les crédits ou augmenter les revenus",
        endettementOk: "Endettement sain",
        ravAlerte: "Réduire certaines dépenses variables",
        ravOk: "Situation confortable",
        variablesAlerte: "Budget dépenses élevé : optimiser alimentation / loisirs",
        variablesOk: "Budget maîtrisé",
        fixesAlerte: "Charges élevées : renégocier assurances / abonnements",
        fixesOk: "Charges fixes correctes",
        rachatOpp: "Proposer un rachat de crédits",
        rachatOk: "Pas de besoin immédiat",
        auditOpp: "Audit assurances recommandé",
        auditOk: "Assurances optimisées",
        budgetOpp: "Proposer une optimisation du budget",
        budgetOk: "Budget bien réparti",
      },
    },
    toasts: {
      saved: "Données sauvegardées localement",
      reset: "Données réinitialisées",
      pdfExported: "Rapport PDF généré",
      resetConfirm: "Réinitialiser toutes les données ?",
    },
  },
  en: {
    appName: "BudgetLens",
    appTagline: "Client budget diagnostic",
    modules: {
      client: "Client",
      revenus: "Income",
      depenses: "Expenses",
      analyse: "Analysis",
      optimisation: "Optimization plan",
      recommandations: "Recommendations",
    },
    nav: {
      exportPdf: "Export to PDF",
      reset: "Reset",
      language: "Language",
      completed: "Completed",
    },
    client: {
      title: "Client information",
      subtitle: "Contextualize your client's profile",
      nom: "Last name",
      prenom: "First name",
      telephone: "Phone",
      email: "Email",
      adresse: "Address",
      situationFamiliale: "Marital status",
      nombreEnfants: "Number of children",
      statutLogement: "Housing status",
      objectifPatrimonial: "Wealth objective",
      horizonPlacement: "Investment horizon",
      situations: {
        celibataire: "Single",
        marie: "Married",
        pacse: "Civil union",
        divorce: "Divorced",
        veuf: "Widowed",
      },
      logements: {
        locataire: "Tenant",
        proprietaire: "Owner",
        heberge: "Hosted",
      },
      horizons: {
        court: "Short term (< 2 years)",
        moyen: "Medium term (2–5 years)",
        long: "Long term (> 5 years)",
      },
      personal: "Contact details",
      family: "Situation & wealth",
    },
    revenus: {
      title: "Monthly income",
      subtitle: "Enter the full household income",
      salaire1: "Salary 1",
      salaire2: "Salary 2",
      bic: "BIC (Commercial profits)",
      bnc: "BNC (Non-commercial profits)",
      dividendes: "Dividends",
      allocationsCaf: "Social allowances",
      pension: "Pension / retirement",
      pensionAlimentaire: "Alimony received",
      autresRevenus: "Other income",
      total: "Total income",
      perMonth: "/ month",
    },
    depenses: {
      title: "Monthly expenses",
      subtitle: "Detailed breakdown of charges",
      fixes: "Fixed charges",
      credits: "Outstanding loans",
      variables: "Variable expenses",
      totalFixes: "Fixed charges subtotal",
      totalCredits: "Loans subtotal",
      totalVariables: "Variable expenses subtotal",
      totalGeneral: "Grand total",
      loyer: "Housing — Rent",
      chargesCopro: "Housing — Building/rental charges",
      assuranceHabitation: "Housing — Home insurance",
      electricite: "Energy — Electricity",
      gaz: "Energy — Gas",
      eau: "Energy — Water",
      telecomInternet: "Telecom — Internet / phone",
      mutuelle: "Insurance — Health",
      autresAssurances: "Insurance — Other (life, protection)",
      assuranceAuto: "Transport — Car insurance",
      carburant: "Transport — Fuel",
      entretienVehicule: "Transport — Vehicle maintenance",
      creditImmo: "Home loan",
      creditAuto: "Car loan",
      creditConso: "Consumer loan",
      creditRenouvelable: "Revolving credit",
      autresCredits: "Other loans",
      alimentation: "Food — Groceries",
      hygienePharmacie: "Hygiene / pharmacy",
      gardeEnfants: "Family — Childcare / school",
      restaurantsSorties: "Leisure — Dining / outings",
      abonnements: "Leisure — Subscriptions",
      autresVariables: "Misc. — Other expenses",
    },
    analyse: {
      title: "Budget analysis",
      subtitle: "Key indicators and instant diagnosis",
      revenusTotaux: "Total income",
      chargesFixes: "Fixed charges",
      mensualitesCredits: "Loan instalments",
      depensesVariables: "Variable expenses",
      depensesTotales: "Total expenses",
      resteAVivre: "Disposable income",
      tauxEndettement: "Debt ratio",
      poidsChargesFixes: "Fixed charges weight",
      poidsVariables: "Variable expenses weight",
      mensualiteMax: "Max bank instalment",
      mensualiteDispo: "Available instalment",
      capaciteEmprunt: "Borrowing capacity",
      diagnostic: "Overall diagnosis",
      diagnosticSaine: "Healthy situation",
      diagnosticSurveiller: "To monitor",
      diagnosticFragile: "Fragile situation",
      endettementCorrect: "Debt ratio OK",
      endettementEleve: "Debt ratio too high",
      ravCorrect: "Disposable income OK",
      ravFaible: "Low disposable income",
      budgetCorrect: "Budget OK",
      budgetOptim: "Budget to optimize",
      threshold: "Threshold",
      repartition: "Expense breakdown",
    },
    optimisation: {
      title: "Optimization plan",
      subtitle: "Simulate potential savings",
      tauxVariables: "Variable expenses reduction rate",
      tauxFixes: "Fixed charges reduction rate",
      economiesVariables: "Savings on variable expenses",
      economiesFixes: "Savings on fixed charges",
      gainMensuel: "Total monthly potential gain",
      nouveauRav: "New estimated disposable income",
      epargneAnnuelle: "Annual savings potential",
      nouveauTaux: "New debt ratio",
      before: "Before",
      after: "After",
      reset: "Default values",
    },
    recommandations: {
      title: "Recommendations",
      subtitle: "Personalized advice and opportunities",
      alertes: "Alerts",
      infos: "Information",
      opportunites: "Opportunities",
      labels: {
        endettement: "Debt ratio",
        rav: "Disposable income",
        variables: "Variable expenses",
        fixes: "Fixed charges",
        rachat: "Loan consolidation",
        audit: "Insurance audit",
        budget: "Budget optimization",
      },
      messages: {
        endettementAlerte: "Reduce loans or increase income",
        endettementOk: "Healthy debt level",
        ravAlerte: "Reduce some variable expenses",
        ravOk: "Comfortable situation",
        variablesAlerte: "High variable budget: optimize food / leisure",
        variablesOk: "Budget under control",
        fixesAlerte: "High charges: renegotiate insurance / subscriptions",
        fixesOk: "Fixed charges OK",
        rachatOpp: "Suggest a loan consolidation",
        rachatOk: "No immediate need",
        auditOpp: "Insurance audit recommended",
        auditOk: "Insurances optimized",
        budgetOpp: "Suggest a budget optimization",
        budgetOk: "Well-balanced budget",
      },
    },
    toasts: {
      saved: "Data saved locally",
      reset: "Data reset",
      pdfExported: "PDF report generated",
      resetConfirm: "Reset all data?",
    },
  },
};

export const formatCurrency = (value, lang = "fr") => {
  const v = Number(value) || 0;
  return new Intl.NumberFormat(lang === "fr" ? "fr-FR" : "en-US", {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: 0,
  }).format(v);
};

export const formatPercent = (value, lang = "fr") => {
  const v = Number(value) || 0;
  return new Intl.NumberFormat(lang === "fr" ? "fr-FR" : "en-US", {
    style: "percent",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(v);
};
